import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UpdateSummaryImplRepository } from './update-summary-imp.repository';
import { GetUpdateSummaryUseCase } from '@/core/domain/update-category/usecases/getSetSummary.usecase';
import { UpdateSummaryRepository } from '@/core/domain/update-category/repositories/update-summary.repository';

const getUpdateSummaryUseCaseFactory = (repository: UpdateSummaryRepository) =>
    new GetUpdateSummaryUseCase(repository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetUpdateSummaryUseCase,
            useFactory: getUpdateSummaryUseCaseFactory,
            deps: [UpdateSummaryImplRepository],
        },
        {
            provide: UpdateSummaryRepository,
            useClass: UpdateSummaryImplRepository,
        },
    ],
})
export class UpdateSummaryDataModule {}
